<template>
  <!-- marketplaces -->
  <div class="box full">
    <div class="box-header">
      Marketplaces
    </div>
    <div class="box-content-block" :key="rendered" v-if="items.length > 0">
      <div class="w-full mx-0 my-4 px-10 grid grid-cols-9 w-full gap-1">
        <div>
          Alias
          <br />
          (SKU Marketplace)
        </div>
        <div>
          Marketplace
        </div>
        <div>
          Marketplace Id
        </div>
        <!-- <div>
          Marketplace Shipping Weight
        </div> -->
        <div class="text-center">
          % Adjustment
        </div>
        <div class="text-center">
          Adjustment fixed
        </div>
        <div class="text-center">
          Export Enabled
        </div>
        <div class="text-center">
          FBA
        </div>
        <div class="text-center">
          Calculated Price
        </div>
        <div class="text-center">
          Actions
        </div>
      </div>
      <ProductMarketplacesManagerItem
        :item="item"
        v-for="item in items"
        :key="item.id"
        @deleted="deletedItem(item.id)"
        @updated="updatedItem"
      />
    </div>
    <div class="flex flex-row items-center">
      <ProductMarketplacesNew :code="code" @created="createdProduct" />
      <ProductMarketplacesPublish :code="code" />
    </div>
  </div>
</template>
<script>
import { loadMarketplacesItems } from "@/api/store/MarketplacesItemsService.js";
import ProductMarketplacesNew from "@/components/product/ProductMarketplacesNew.vue";
import ProductMarketplacesManagerItem from "@/components/product/ProductMarketplacesManagerItem.vue";
import ProductMarketplacesPublish from "@/components/product/ProductMarketplacesPublish.vue";

export default {
  name: "ItemMarketplacesManager",
  components: {
    ProductMarketplacesManagerItem,
    ProductMarketplacesNew,
    ProductMarketplacesPublish
  },
  data() {
    return {
      loading: false,
      editProduct: "",
      items: [],
      rendered: 0,
      showNewModal: false,
      newProduct: null
    };
  },
  props: {
    code: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    loadItems() {
      this.loading = true;
      loadMarketplacesItems(this.code).then(res => {
        this.items = res;
      });
    },
    deletedItem(id) {
      this.items = this.items.filter(item => item.id !== id);
    },
    updatedItem(newItem) {
      console.log("andres", newItem);
      const index = this.items.findIndex(item => item.id === newItem.id);
      console.log({ index });
      console.log("found", this.items[index]);
      this.items[index] = JSON.parse(JSON.stringify(newItem));
      this.rendered = this.rendered + 1;
    },
    createdProduct(product) {
      this.items.push(product);
    }
  }
};
</script>
